import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

export default class CheckBoxField extends Component {
  render() {
    const {
      id,
      input,
      label,
      type,
      error,
      touched,
      disabled,
      singleLine
    } = this.props;

    const showError = error && touched;

    const inputBlock = () => {
			return (
        <div className="form-group form-check">
          <input 
            type="checkbox" 
            className="form-check-input" 
            id={input.name} 
            checked={input.value} 
            onChange={input.onChange}
            disabled={disabled}
            value={input.value} 
          />
          <label className="form-check-label" style={{ paddingLeft: '5px' }} htmlFor={input.name}>{label}</label>
        </div>
			);
		};
    
    if (singleLine) {
      return (
        <FormGroup
          controlId={id || input.name}
          type={type}
          validationState={showError ? 'error' : null}
        >
          {inputBlock()}
        </FormGroup>
      );
    }

    return (
      <FormGroup
        controlId={id || input.name}
        type={type}
        label={label}
        placeholder="Place Holder"
        validationState={showError ? 'error' : null}
        className="control-label-horizontal"
      >
        {label ? <ControlLabel>{label}</ControlLabel> : ''}
        <FormControl
          id={input.name} 
          name={input.name} 
          checked={input.value} 
          onChange={input.onChange} 
          disabled={disabled}
          type='checkbox'
          value={input.value}
        />
      </FormGroup>
    );
  }
}

